module.exports = __webpack_public_path__ + "static/media/simple.d87bcbd4.png";